export default function BrowserFrame({ url, children, className = "" }) {
  return (
    <div
      className={`overflow-hidden rounded-xl border border-line bg-subtle shadow-2xl shadow-black/40 ${className}`}
    >
      <div className="flex items-center gap-2 border-b border-line bg-elev px-4 py-2.5">
        <span className="h-2.5 w-2.5 rounded-full bg-[#3A4046]" />
        <span className="h-2.5 w-2.5 rounded-full bg-[#3A4046]" />
        <span className="h-2.5 w-2.5 rounded-full bg-[#3A4046]" />
        <span className="ml-3 flex h-7 flex-1 items-center overflow-hidden rounded-md bg-subtle px-3 text-[11px] text-dim">
          {url}
        </span>
      </div>
      {children}
    </div>
  );
}
